/* eslint-disable @typescript-eslint/no-explicit-any */
import { Logger } from './Logger';
import { LoggerFactory } from './LoggerFactory';

export class ConsoleLogger implements Logger {
	constructor(private readonly category: string) {}

	debug(message: string, ...args: any): void {
		this.log(LoggerFactory.logger.debug, 'Debug', message, args);
	}

	info(message: string, ...data: any): void {
		this.log(LoggerFactory.logger.info, 'Info', message, data);
	}

	warn(message: string, ...args: any): void {
		this.log(LoggerFactory.logger.warn, 'Warn', message, args);
	}

	error(message: string, ...args: any): void {
		this.log(LoggerFactory.logger.error, 'Error', message, args);
	}

	private log(
		logFunction: (message: string, data?: any[]) => void,
		level: string,
		message: string,
		data: any[]
	): void {
		const date = new Date();
		const newMessage = `[${date.toLocaleTimeString()}.${date.getMilliseconds()}] [${level}] [${
			this.category
		}] ${message}`;
		if (data.length == 0) {
			logFunction(newMessage);
		} else {
			logFunction(newMessage, ...data);
		}
	}
}
